import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form,Tooltip, Button, Spinner, Alert, Card } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { newSubProductCreation,resetSubProductCreatiion } from "./subproductAction";
import { newAdultRatesCreation,newChildRatesCreation,newInfantRatesCreation,newSeasonalRatesCreation ,newPromotionRatesCreation} from "../rates/ratesAction";
import { newItenaryCreation,getSingleProductItenary } from "../itenary/itenaryAction";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight, faRightToBracket, faUpload, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import Datetime from "react-datetime";
import { DefaultEditor } from 'react-simple-wysiwyg';
import { upload } from '@testing-library/user-event/dist/upload';
import UploadService from "../../../api/FileUploadApi";
import { useNavigate, useParams, Link } from 'react-router-dom';
import Swal from 'sweetalert2'
import { getAllProduct } from "../product/productAction";
import { FaEye, FaArrowAltCircleRight, FaTrash, FaPlus,FaArrowLeft} from 'react-icons/fa';
// import { Tooltip } from 'react-tooltip';
import moment from 'moment';
const ViewItenaryPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { SubProductId } = useParams();
    const {pid}=useParams();
    const {pname}=useParams();
    const SubProductRef = useRef(null);
    const [productid, setProductid] = useState('');
    const [subproductname, setSubproductname] = useState('');
    const [status, setStatus] = useState('');
    const [status2, setStatus2] = useState('');
    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const [terms, setTerms] = useState('');
    const [abouttour, setAboutTour] = useState('');
    const [addinfo, setAddInfo] = useState('');
    const [pickuploc, setPickUpLoc] = useState('');
    const [dailystarttime, setDailystarttime] = useState('');
    const [dailyendtime, setDailyendtime] = useState('');

    const { itenary } = useSelector((state) => state.productitenaryList);

    const data1  = useSelector((state) => state.productitenaryList?.itenary?.data1 || []);
    const data2  = useSelector((state) => state.productitenaryList?.itenary?.data2 || []);
    const data3  = useSelector((state) => state.productitenaryList?.itenary?.data3 || []);
    const onBack = () => {
   
        navigate('/subproductListId/' + pid + "/" + pname); 
     }

const datamap = [data1]
    console.log("data1",data1)
    console.log("data2",data2)
    console.log("data3",data3)

    useEffect(() => {
        dispatch(getSingleProductItenary(SubProductId));

    }, []);


    const canSave = Boolean(productid) && Boolean(subproductname) && Boolean(status)
    const canSave2 = Boolean(dailyendtime) && Boolean(dailystarttime) && Boolean(abouttour) && Boolean(terms) && Boolean(status2)

    if (data1.length === 0) {
        return (
            <>
                <Container className="my-4 mx-4 container-xl">
                    <div style={{ display: 'flex', justifyContent: 'flex-start' }}>{' '}</div>
                </Container>
                <Container className="my-4 mx-4 container-xl">

                <table id="example" className="table table-hover table-bordered display" style={{ "width": "100%", marginLeft: '130px', marginRight: '-100px'  }}>
                        <thead>
                            <tr>
                                <th style={{backgroundColor:'rgb(0 0 0 / 3%)',padding:'10px'}}>
                                <div><span className="badge bg-success" onClick={onBack} style={{backgroundColor:'rgb(156 186 237)',color:'white' ,cursor:'pointer'}}><FaArrowLeft />&nbsp;Go Back</span></div>
                                <h4>Itinerary View</h4></th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{textAlign:'center'}}>No Data Available.</td>
                               
                            </tr>


                        </tbody>
                    </table>



                </Container>
            </>
        );
    }

    return (
        <>
            <Container className="my-4 mx-4 container-xl ">

            <Card  style={{marginLeft:'100px',marginTop:'-60px'}}>
                    <Card.Header><h4 className="d-flex text-dark text-left mt-2 mb-2"  style={{fontFamily:'Times New Roman', fontWeight:'600' }}>View Itinerary Details</h4></Card.Header>
                    <Card.Body>
                        <Row>
                            <div><span className="badge bg-success" onClick={onBack} style={{ backgroundColor: 'rgb(156 186 237)', color: 'white', cursor: 'pointer' }}><FaArrowLeft />&nbsp;Go Back</span></div>

                        </Row>
                        <br />
                       



                                <Form className=" mx-4 my-2" component="form" noValidate autoComplete="off"> {/* handleOnSubmit() */}

                                {datamap[0]?.map((item)=>{

                                    return <>
                                         <Row className="mb-3">
                                        <Form.Group disabled as={Col} controlId="formGridDialyStartTime">
                                            <Form.Label>Daily Start Time <span className='text-danger'>*</span> </Form.Label>
                                            <Form.Control initialViewMode="" name="dailystarttime" value={moment(item?.daily_start_time).format('HH:mm A')} disabled={true} updateOnView="" dateFormat={false} timeFormat="HH:mm A" selected={dailystarttime} onChange={dailystarttime => setDailystarttime(dailystarttime)} />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="formGridDialyEndTime">
                                            <Form.Label>Daily End Time<span className='text-danger'>*</span> </Form.Label>
                                            <Form.Control initialViewMode="time" name="dailyendime" disabled updateOnView="time" value={moment(item?.daily_end_time).format('HH:mm A')} dateFormat={false} timeFormat="HH:mm A" selected={dailyendtime} onChange={dailyendtime => setDailyendtime(dailyendtime)} />

                                        </Form.Group>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Group as={Col} controlId="formGridProductdescription">
                                            <Form.Label>About Tour<span className='text-danger'>*</span></Form.Label>

                                            <DefaultEditor rows="5" disabled ref={SubProductRef} value={item?.about_tours}  name="abouttour" {...register("abouttour", { required: true, mixLength: 3 })} onChange={(e) => setAboutTour(e.target.value)}
                                            />

                                        </Form.Group>


                                    </Row>

                                    <Row className="mb-3">
                                        <Form.Group as={Col} controlId="formGridProductdescription">
                                            <Form.Label>Additional Info<span className='text-danger'></span></Form.Label>

                                            <DefaultEditor rows="5" disabled ref={SubProductRef} value={item?.additional_info} name="addinfo" {...register("addinfo", { required: true, mixLength: 3 })} onChange={(e) => setAddInfo(e.target.value)}
                                            />

                                        </Form.Group>
                                    </Row>

                                    <Row className="mb-3">
                                        <Form.Group as={Col} controlId="formGridProductdescription">
                                            <Form.Label>Pick Up Location<span className='text-danger'></span></Form.Label>

                                            <DefaultEditor rows="5" disabled ref={SubProductRef} value={item?.pickup_loc} name="pickuploc" {...register("pickuploc", { required: true, mixLength: 3 })} onChange={(e) => setPickUpLoc(e.target.value)}
                                            />

                                        </Form.Group>


                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Group as={Col} controlId="formGridProductdescription">
                                            <Form.Label>Terms & Conditions<span className='text-danger'>*</span></Form.Label>

                                            <DefaultEditor rows="5" disabled ref={SubProductRef}  value={item?.terms} name="terms" {...register("terms", { required: true, mixLength: 3 })} onChange={(e) => setTerms(e.target.value)}
                                            />

                                        </Form.Group>


                                    </Row>
                                    <Row className="mb-3">

                                <Form.Group as={Col} controlId="formGridStatus">
                                    <Form.Label>Status<span className='text-danger'>*</span></Form.Label>
                                    <Form.Select required name="status2" disabled value={item?.status} onChange={(e) => setStatus2(e.target.value)}>

                                        <option value="">Choose..</option>
                                        <option value="1">Enable</option>
                                        <option value="0">Disable</option>
                                    </Form.Select>
                                    {errors.status2 && <p className='text-danger'>Status required</p>}
                                </Form.Group>

                                    </Row>
                                    
                                    
                                    </>
                                })}
                               

                                    <Card>
                                        <h6 style={{ textAlign: 'center', marginTop: '10px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}><u>Service Inclusions</u><span className='text-danger'>*</span></h6>
                                        <hr />
                                        <Row className='mb-3'>
                                            {data2?.map((item)=>{
                                                return <>
                                                <ul>
                                                    <li style={{marginLeft:'25px'}}>{item.service_include}</li>
                                                </ul>
                                                
                                                </>
                                            })}



                                        </Row>
                                    </Card>
                                    <br />
                                    <Card>
                                        <h6 style={{ textAlign: 'center', marginTop: '10px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}><u>Service Exclusions</u><span className='text-danger'>*</span></h6>
                                            <hr />
                                        <Row className='mb-3'>
                                            {data3?.map((item)=>{
                                                return <>
                                                <ul>
                                                    <li style={{marginLeft:'25px'}}>{item.service_include}</li>
                                                </ul>
                                                
                                                </>
                                            })}



                                        </Row>
                                    </Card>

                                 

                                  
                                </Form>


                        
                    </Card.Body>
                </Card>

            </Container>
        </>
    );
}

export default ViewItenaryPage;